import { RefObject } from 'react';

import { useAvailableHeight } from './useAvailableHeight';
import { resolveHeight } from '../_utils';

export const useListHeight = (
  rootRef: RefObject<HTMLElement | null>,
  headerRef: RefObject<HTMLElement | null>,
  config: {
    totalListHeight: number;
    height?: string | number;
    minHeight?: number | string;
    maxHeight?: number | string;
  }
): number | null => {
  const { totalListHeight, height: _height, minHeight, maxHeight } = config;
  const fillParentHeight = _height === 'fill-parent';

  const availableHeight = useAvailableHeight(
    rootRef,
    headerRef,
    fillParentHeight
  );

  // Fixed height — ignore everything else
  if (_height !== undefined && !fillParentHeight) {
    return resolveHeight(rootRef, _height) ?? totalListHeight;
  }

  // fill-parent: still measuring
  if (fillParentHeight && availableHeight === null) {
    return null;
  }

  const resolvedMaxHeight = Math.min(
    resolveHeight(rootRef, maxHeight) ?? Infinity,
    availableHeight ?? Infinity
  );
  const resolvedMinHeight = Math.min(
    resolveHeight(rootRef, minHeight) ?? 0,
    totalListHeight
  );

  // Guard against totalListHeight being 0 on initial Virtuoso render
  const height =
    totalListHeight > 0
      ? Math.min(totalListHeight, resolvedMaxHeight)
      : resolvedMaxHeight;

  return Math.max(resolvedMinHeight, height);
};
